<template>

<div id="header">
  <!-- 모바일 전용 헤더 -->
	<!-- top line 로그인 회원가입 -->
  <!-- <div class="container" v-if="isLogin"> -->
    <!-- <ul class="menu_wrap"> -->
      <!-- <li class="icon_menu"  @click="setTopMenu" ></li> -->
<!--       <li class="pc sch"><a   @click="go1('mypage', '/qrcode/qrcode_scan')"> 출입조회</a></li> -->
    <!-- </ul> -->
  <!-- </div> -->
	<div id="lmenu_wrap"> <!--lmenu_wrap :: 모바일 전용 (왼쪽메뉴) -->
    <div class="top doMinMenu ">
      <div class="container">
          <!-- <ul>
            <li class="remote pc"><a @click="goRemotPage">원격지원</a></li>

          </ul> -->
          <ul  class="top_userinfo doMinMenu">


            <template v-if="isLogin"><!-- 로그인시에만 -->
              <template v-if="isMyPage"> <!-- 마이페이지인 경우 (로그인/확인/스캔이 아닌경우) -->
                <li><s-link tag="dd" to="/mypage/hist_qrcode">조회기록</s-link></li>
                <li><s-link tag="dd" to="/mypage/hist_login">접속기록</s-link></li>
                <li><s-link tag="dd" to="/mypage/myinfo">내정보 확인</s-link></li>
                <li><s-link tag="dd" to="/mypage/change_pw">비밀번호 변경</s-link> </li>
                <!-- <li><dd @click="goRemotPage">원격지원</dd></li> -->
                <li><s-link tag="dd" :to="_config.LOGOUT_PATH">로그아웃</s-link></li>
                <li><s-link tag="dd" to="/qrcode/qrcode_scan" title="조회로 돌아가기">변호사 신분 확인 시스템 </s-link></li>
              </template>
              <template v-else-if="$route.path == '/member/pw_confirm'"> <!-- 마이페이지 진입 전 -->
                <li><s-link tag="dd" :to="_config.LOGOUT_PATH">로그아웃</s-link></li>
                <li><s-link tag="dd" to="/qrcode/qrcode_scan" title="조회로 돌아가기">변호사 신분 확인 시스템</s-link></li>
              </template>
              <template v-else><!-- qrcode 스캔화면 -->

                <li class="pc right"><a class="member" @click="$router.push('/member/pw_confirm')">
                  {{ this.$store.getters["session/user"].court0nm }} -
                  {{ this.$store.getters["session/user"].court1nm }} -
                  {{ this.$store.getters["session/user"].id }} &nbsp;
                  <img src="/images/common/icon_memeber.png">
                </a></li>
              </template>


              <!-- <li class="pc" ><a class="sch" @click="go1('mypage', '/qrcode/qrcode_scan')"> 출입조회</a></li> -->

              <!-- <li class="pc" ><a class="member" @click="go1('mypage', '/mypage/myinfo')"> 마이페이지</a></li> -->


            </template>

<!--             <template v-else>
              <li><router-link tag="dd" :to="_config.LOGIN_PATH" class="login">로그인</router-link> </li>
            </template> -->



          </ul>
      </div> <!-- container -->

    </div>




      <!-- 상단 메뉴  -->

		<div class="m_toptit_bg"></div> <!-- mobile전용  title bg -->
		<div class="btn_mback" onclick="history.go(-1);"><img src="/images/common/btn_mback01.png"></div> <!--  MOBLIE : 뒤로가기 -->
	<!-- 상단 메뉴 끝 -->
</div>

  <!-- <dev-comment-editor ref="devMemo" v-if="$store.getters['session/isLogin']" :devStatus.sync="devStatus"/> -->
  <!-- <help-comment-editor ref="helpMemo" v-if="$store.getters['session/isLogin']" :helpStatus.sync="helpStatus"/> -->
</div>



</template>


<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    // 'dev-comment-editor' : require('@/components/DevCommentEditor.vue').default,
    // 'help-comment-editor' : require('@/components/HelpCommentEditor.vue').default,
  },
  props : {
    hideSubTop: {
        type: Boolean,
        default: false
    },
  },
  data() {
    return {
      mobileSmenu: '',
      devStatus: '',
      helpStatus :'',
    }
  },
  computed: {
    isMyPage() {
      switch(this.$route.path) {
        case "/member/login": return false
        case "/member/pw_confirm": return false
        case "/qrcode/qrcode_scan": return false
      }
      return true
    },
    ...mapGetters('session', ['user', 'isLogin']),
    path() { return this.$route.path },
    loginTypeName() {
      switch (this.$store.state.session.user.type) {
        case "self": return "개인변호사"
        case "member": return "소속"
        case "master": return "마스터"
      }
      return ""
    },
  },
  mounted() {
    // if (this.$device.isMobile) {
      $('#lmenu_wrap ul li dd').click(this.toggle)
      this.setHover()
    // }
  },
  watch: {
    '$mq'(v) {
      switch(v) {
        case 'desktop':
          this.setHover()
          return $('#lmenu_wrap').show()
        case 'mobile' :
          this.mobileSmenu = this.$route.meta.smenu // 모바일로 전환시 현재 페이지의 smenu복사
          $('#header .gnb_wrap').off('mouseenter mouseleave').height("100%")
          return $('#lmenu_wrap').hide()
      }
    },
    '$route': 'setHover',
  },
  methods: {
    toggle() {
      if (this.$mq === 'mobile') {
        $('#lmenu_wrap').toggle();
      } else {
        $('#header .gnb_wrap').height("90px")
      }
    },
    setHover() {
      if (this.$mq == 'desktop') {
        $('#header .gnb_wrap')
          .off('mouseenter mouseleave')
          .height("90px")
          .hover(()=>{
              $('#header .gnb_wrap').height("305px")
          },()=> {
              $('#header .gnb_wrap').height("90px")
          })
      }
    },
    setTopMenu() {
      if (this.$route.path == '/qrcode/qrcode_scan') {
        this.$router.push('/member/pw_confirm');
      } else {
        this.$router.push('/qrcode/qrcode_scan');
      }
    },

    goRemotPage() {
      if (confirm("원격지원 페이지로 이동하시겠습니까 ?")) {
        window.open("https://939.co.kr/koreanbar/", '_blank');
      }
    },

    go1(smenu, path) {
      return this.$router.push(path) // 데스크탑 모드일땐 무조건 해당 링크로 이동
    },
  },
}


</script>
<style>


</style>
